import { render, staticRenderFns } from "./Travel_add.vue?vue&type=template&id=38f7b897&"
import script from "./Travel_add.vue?vue&type=script&lang=js&"
export * from "./Travel_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports